// src/selectors/ProductSelector.js
import { createSelector } from "reselect";

const getProductsState = (state) => state.products;

export const selectProducts = createSelector(
  [getProductsState],
  (productsState) => productsState.products || []
);

export const selectBestSellerProducts = createSelector(
  [selectProducts],
  (products) => {
    return products.filter((product) => {
      return product.tags && product.tags.includes("BEST SELLER");
    });
  }
);

export const selectNewProducts = createSelector(
  [selectProducts],
  (products) => {
    return products.filter((product) => {
      return product.tags && product.tags.includes("NEW ARRIVAL");
    });
  }
);

export const SelectTrendingProducts = createSelector(
  [selectProducts],
  (products) => {
    return products.filter((product) => {
      return product.tags && product.tags.includes("HOT DEAL");
    });
  }
);
